import { Factory, ShoppingCart, TrendingUp, Sprout, Truck, HardHat } from "lucide-react";

// Role registry: card copy + role-specific form fields
export const ROLES = [
  {
    key: "Manufacturer",
    title: "Manufacturer",
    tagline: "Produce & supply pellets/briquettes",
    description:
      "Register your unit, publish capacity, and connect with verified bulk buyers across India.",
    icon: Factory,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/ivh54cnp_manufactring.webp",
    fields: [
      { name: "company", label: "Company / Unit Name", required: true },
      { name: "gstin", label: "GSTIN", required: true, hint: "15-char GSTIN" },
      { name: "capacity", label: "Monthly Capacity (Tonnes)", required: true, type: "number" },
      { name: "material", label: "Material Type", required: true, hint: "e.g. Wood pellets, Briquettes" },
    ],
  },
  {
    key: "Buyer",
    title: "Buyer",
    tagline: "Source pellets & briquettes",
    description:
      "Post your monthly requirement and receive verified quotes from vetted manufacturers.",
    icon: ShoppingCart,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/isw5ywe6_buyer%20seller.jpg",
    fields: [
      { name: "company", label: "Company / Industry", required: true },
      { name: "quantity", label: "Required Quantity (Tonnes/Month)", required: true, type: "number" },
      { name: "material", label: "Material Needed", required: true, hint: "Pellets / Briquettes / Both" },
      { name: "gstin", label: "GSTIN (optional)" },
    ],
  },
  {
    key: "Seller",
    title: "Seller / Trader",
    tagline: "Commission agents & traders",
    description:
      "List your active stock, connect buyers and manufacturers, close deals faster.",
    icon: TrendingUp,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/0g1amca3_trader%201111.png",
    fields: [
      { name: "firm", label: "Firm / Trading Name", required: true },
      { name: "gstin", label: "GSTIN", required: true },
      { name: "materials", label: "Materials Traded", required: true, hint: "e.g. Wood chips, briquettes" },
      { name: "regions", label: "Operating Regions", hint: "States / Cities" },
    ],
  },
  {
    key: "Farmer",
    title: "Farmer",
    tagline: "Sell crop residue directly",
    description:
      "Turn stubble & residue into income. Direct offtake from nearby manufacturers.",
    icon: Sprout,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=1200&q=80",
    fields: [
      { name: "residue", label: "Crop Residue Type", required: true, hint: "e.g. Paddy straw, sugarcane trash" },
      { name: "quantity", label: "Quantity Available (Tonnes)", required: true, type: "number" },
      { name: "land_area", label: "Land Area (Acres)", type: "number" },
    ],
  },
  {
    key: "Transporter",
    title: "Transporter",
    tagline: "Logistics & fleet operators",
    description:
      "Register your fleet and route capacity. Get consistent loads from the network.",
    icon: Truck,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1200&q=80",
    fields: [
      { name: "fleet_size", label: "Fleet Size", required: true, type: "number" },
      { name: "vehicle_types", label: "Vehicle Types", required: true, hint: "e.g. 20-ton trucks, containers" },
      { name: "routes", label: "Preferred Routes", hint: "Regions you cover" },
    ],
  },
  {
    key: "Labour",
    title: "Labour",
    tagline: "Skilled workforce",
    description:
      "Register skills and availability to get connected with manufacturing units.",
    icon: HardHat,
    accent: "from-emerald-400/20 to-transparent",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/d5doujed_labour%20pic.webp",
    fields: [
      { name: "skills", label: "Skills / Experience", required: true, hint: "e.g. Loader, machine operator" },
      { name: "availability", label: "Availability", required: true, hint: "Full-time / Part-time / Contract" },
      { name: "wage", label: "Expected Wage (per day/month)" },
    ],
  },
];

export const getRole = (key) => ROLES.find((r) => r.key === key);
